var handleOnClick = function (elementId, action) {
    var element = document.getElementById(elementId);
    if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        action && action();
    }
};
export default handleOnClick;
